







































































































































































































import { Vue, Component, Watch, Prop } from "vue-property-decorator";
import SelectEntity from "@/components/form/SelectEntity.vue";
import Employee, { EmployeeListParams } from "@/getinfo-api/employee";
import { EducationProtocol as IEducationProtocol } from "@/api/models/education-protocol";
import { EducationProtocolEdit as IEducationProtocolEdit } from "@/api/models/education-protocol-edit";
import { CourseListenersUnionList as ICourseListenersList } from "@/api/models/course-listeners-union-list";
import { CourseListenerUnion as ICourseListener } from "@/api/models/course-listener-union";
import { Course as ICourse } from "@/api/models/course";
import { Employee as IEmployee } from "@/api/models/employee";
import { EmployeesList2 as IEmployeesList2 } from "@/api/models/employees-list2";
import CustomDatepicker from "@/components/form/CustomDatepicker.vue";
import { CommissionPerson as ICommissionPerson } from "@/api/models/commission-person";
import { CommissionMembers as ICommissionMembers } from "@/api/models/commission-members";
import { isRoot, getCurrentUserId, getCurrentCompanyId } from "@/plugins/roles";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import { CompanyDocumentInfo as ICompanyDocumentInfo } from "@/api/models/company-document-info";
import educationsListeners, {
  EducationListenersListParams
} from "@/getinfo-api/educations-listeners";
import api from "@/getinfo-api";
import ListenerTable from "@/components/tables/ListenerTable.vue";
import { mapGetters } from "vuex";
import Modal from "@/components/form/Modal.vue";
import CMultiSelect from "@/components/form/CMultiSelect.vue";
import CField from "@/components/form/CField.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import DocumentNumberInput from "@/components/form/DocumentNumberInput.vue";
import { nextSequence } from "@/utils/generate-helper";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import { CoursesListClass } from "@/classes/list/CoursesListClass";

@Component({
  computed: {
    ...mapGetters({
      SELECTED_LISTENERS: "SELECTED_LISTENERS",
      LISTENERS: "LISTENERS"
    })
  },
  components: {
    CSingleSelect,
    DocumentNumberInput,
    CustomButton,
    Modal,
    ListenerTable,
    SelectEntity,
    CustomDatepicker,
    CMultiSelect,
    CField
  }
})
export default class EducationProtocolForm extends Vue {
  @Prop() educationProtocol?: IEducationProtocol;
  @Prop() propListeners?: ICourseListener[];
  @Prop() propEducationFinishedAt?: Date;
  @Prop() propEducationStartedAt?: Date;
  @Prop() propCourseId!: string;
  @Prop({ default: false }) isNewWindowOnSave?: boolean;
  educationStartedAt!: Date;
  formedAt!: Date;
  signedAt!: Date | undefined;
  employeeId?: string | undefined;
  course?: ICourse | undefined;
  courseId!: string;
  protocolNum!: string;
  courseListeners: Array<ICourseListener> = [];
  reason!: string | undefined;
  employee!: IEmployee | undefined;
  checkedListeners: Array<ICourseListener> = [];
  gettingCommission: boolean = false;
  gettingListeners: boolean = false;
  protocolCreating: boolean = false;
  isSavingProcess: boolean = false;
  commission: ICommissionMembers = {
    chairman: undefined,
    secretary: undefined,
    commission: []
  };
  companyCommission!: Array<ICommissionPerson> | undefined;
  coursesList: CoursesListClass = new CoursesListClass(
    { mode: "v2" },
    this.propCourseId
      ? this.propCourseId
      : this.educationProtocol
      ? this.educationProtocol.course.id
      : ""
  );

  data() {
    return {
      companyCommission: undefined,
      course: undefined,
      courseId: undefined,
      employeeId: undefined,
      formedAt: undefined,
      signedAt: undefined,
      protocolNum: undefined,
      chairman: undefined,
      educationStartedAt: undefined,
      currentCommisionMember: undefined,
      courseListenersList: undefined,
      reason: undefined,
      employee: undefined
    };
  }

  returnThisDay() {
    this.formedAt = new Date();
  }

  get courseProp() {
    return this.educationProtocol
      ? this.educationProtocol.course.id
      : undefined;
  }

  get selectedListenersId() {
    return this.checkedListeners.map(el => el.id);
  }

  getCheckedListeners(items: Array<ICourseListener>) {
    this.checkedListeners = items;
  }

  selectCourse(course: ICourse) {
    if (this.educationProtocol) {
      this.course = course;
    } else if (course) {
      this.course = course;
    }
  }

  get selectedCompany() {
    return getCurrentCompanyId();
  }

  get companyOwner() {
    return this.$store.getters.userIsCompanyOwner;
  }

  get root() {
    return isRoot();
  }

  get userId() {
    return getCurrentUserId();
  }

  async createProtocol() {
    if (await this.$store.dispatch("validate/CHECK_VALIDATIONS")) return;
    this.isSavingProcess = true;
    if (this.$store.getters.GET_FORM_IS_INVALID) {
      return;
    }
    if (this.selectedListenersId.length === 0) {
      this.$bvToast.toast(
        `${this.$tc(this.$translate.AtLeastOneUserMustBeSelected)}`,
        {
          variant: "danger",
          title: `${this.$tc(this.$translate.Error)}`
        }
      );
      this.isSavingProcess = false;
      return false;
    }

    if (this.educationProtocol) {
      this.protocolCreating = true;
      let params: IEducationProtocolEdit = {
        number: this.protocolNum,
        ownerId: this.educationProtocol.owner.id,
        courseId: this.educationProtocol.course.id,
        fileIds: this.educationProtocol.files?.map((el: any) => el.id),
        commission: this.commission,
        protocolCreatedAt: this.formedAt,
        signedAt: this.signedAt,
        listeners: this.selectedListenersId,
        reason: this.reason
      };
      api.EducationProtocolApi.edit(this.educationProtocol.id, params)
        .then(async (res: { data: IEducationProtocol }) => {
          await nextSequence();
          await this.$router.push({
            name: "educationProtocol",
            params: {
              id: res.data.id
            }
          });
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        })
        .finally(() => {
          this.protocolCreating = false;
          this.isSavingProcess = false;
        });
    } else {
      this.isSavingProcess = true;
      if (this.employee && this.course) {
        this.protocolCreating = true;
        let params: IEducationProtocolEdit = {
          fileIds: [],
          listeners: this.selectedListenersId,
          number: this.protocolNum,
          ownerId: this.employee.id,
          courseId: this.course.id,
          commission: this.commission,
          protocolCreatedAt: this.formedAt,
          signedAt: this.signedAt,
          reason: this.reason
        };
        api.EducationProtocolApi.create(params)
          .then(async (res: { data: IEducationProtocol }) => {
            await nextSequence();
            if (this.isNewWindowOnSave) {
              let routeData = this.$router.resolve({
                name: "educationProtocol",
                params: { id: res.data.id }
              });
              await window.open(routeData.href, "_blank");
              this.$emit("saveProtocol", res.data);
            } else {
              await this.$router.push({
                name: "educationProtocol",
                params: {
                  id: res.data.id
                }
              });
            }
          })
          .catch(
            (err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
              this.$store.dispatch("errorException", {
                vm: this,
                error: err.response
              });
            }
          )
          .finally(() => {
            this.protocolCreating = false;
            this.isSavingProcess = false;
          });
      }
    }
  }

  getCommission() {
    this.gettingCommission = true;
    api.CompanyApi.getDocumentInfo(this.selectedCompany)
      .then((res: { data: ICompanyDocumentInfo }) => {
        this.companyCommission = res.data.commissionPersons;
        if (this.educationProtocol) {
          this.commission = this.educationProtocol.commission;
        }
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      })

      .finally(() => {
        this.gettingCommission = false;
      });
  }

  removeProtocol() {
    if (this.educationProtocol)
      api.EducationProtocolApi._delete(this.educationProtocol.id)
        .then(() => {
          this.$router.push({
            name: "educationProtocolList"
          });
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        });
  }

  getEmployeeByCourse() {
    this.employee = undefined;
    if (this.course) {
      let params: EmployeeListParams = {
        id: this.selectedCompany,
        userIds: [this.course?.owner.id]
      };
      Employee(params).then((res: { data: IEmployeesList2 }) => {
        this.employee = res.data.employees[0];
      });
    }
  }

  getListenersList() {
    if (this.course && !this.educationProtocol) {
      this.$store.dispatch("CLEAR_LISTENERS");
      this.gettingListeners = true;

      let params: EducationListenersListParams = {
        courseId: this.course.id,
        hasProtocol: false,
        limit: 999
      };

      if (this.educationStartedAt) {
        params.createdAtMin = new Date(this.educationStartedAt);
        let educationStartedAtMax = new Date(this.educationStartedAt);
        educationStartedAtMax.setHours(23);
        educationStartedAtMax.setMinutes(59);
        params.createdAtMax = educationStartedAtMax;
      }

      educationsListeners(params)
        .then((res: { data: any }) => {
          this.$store.dispatch("ADD_LISTENERS", res.data.listeners);
        })
        .finally(() => {
          this.gettingListeners = false;
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        });
    } else if (this.course && this.educationProtocol) {
      // @ts-ignore
      let params: EducationListenersListParams = {
        courseId: this.course.id,
        hasProtocol: false,
        limit: 999
      };
      educationsListeners(params).then(
        (res: { data: ICourseListenersList }) => {
          this.$store.dispatch("ADD_LISTENERS", res.data.listeners);
        }
      );
    }
  }

  @Watch("course")
  checkCourse() {
    this.getEmployeeByCourse();
    this.getListenersList();
  }

  @Watch("educationStartedAt")
  checkStartData() {
    this.$store.dispatch("CLEAR_LISTENER_TABLE_STATE");
    this.getListenersList();
  }

  mounted() {
    if (this.educationProtocol) {
      this.courseId = this.educationProtocol.course.id;
      this.formedAt = this.educationProtocol.protocolCreatedAt;
      // this.formedAt = this.educationProtocol.createdAt;
      this.signedAt = this.educationProtocol.signedAt;
      this.protocolNum = this.educationProtocol.number;
      this.reason = this.educationProtocol.reason;
    } else {
      this.formedAt = new Date();
    }

    if (this.propCourseId) {
      this.courseId = this.propCourseId;
    }

    if (this.propEducationStartedAt) {
      this.educationStartedAt = new Date(this.propEducationStartedAt);
      console.log(this.educationStartedAt);
      this.educationStartedAt.setHours(0, 0, 0, 0);
    }

    if (this.propEducationFinishedAt) {
      this.formedAt = this.propEducationFinishedAt;
    }
    this.getCommission();
  }
}
